import React, { useEffect, useRef, useState } from 'react';

import { TableItem } from '@Calix-Commerce/design-system/components';

import {
  InfoFields,
  InfoColumn,
} from 'pages/Order/subcomponents/ItemDetailsTable/styledComponents';
import { ShipmentBlock } from 'pages/Order/subcomponents/ItemDetailsTable/ShipmentBlock';

import { ExtendedWarrantyBlock } from './ExtendedWarrantyBlock';
import { UnitsTable } from './UnitsTable';
import { ItemTrackingDetails } from './../ItemTrackingDetails';
import { CollapsibleRows, SubRowDotted, SubRow, ExpandedChildRowSecondaryColumn } from './styles/styledComponents';

const renderWarrantyRow = (lineData, isEvenRow) =>
  lineData.warrantyLine ? (
    <SubRow darkBackground={isEvenRow}>
      <td />
      <td colSpan="2">
        <ExtendedWarrantyBlock lineData={lineData.warrantyLine} darkBackground={!isEvenRow} />
      </td>
      <td />
    </SubRow>
  ) : null;

const renderCollapsedRows = (isEvenRow, lineData) => {
  const bomLines = lineData.bomLines || [];

  return (
    <>
      {renderWarrantyRow(lineData, isEvenRow)}
      {bomLines.map((bomLine, i) => {
        return (
          <>
            <SubRowDotted darkBackground={isEvenRow}>
              <td>
                <div>{bomLine.displayLineNumber}</div>
              </td>
              <td colSpan="2">
                <InfoFields>
                  <InfoColumn>
                    <div>
                      <b>Part Number:</b> <TableItem>{bomLine.partNumber}</TableItem>
                    </div>
                  </InfoColumn>
                  <InfoColumn>
                    <ExpandedChildRowSecondaryColumn>
                      <b>Status:</b> {bomLine.lineStatus}
                    </ExpandedChildRowSecondaryColumn>  
                  </InfoColumn>
                </InfoFields>
              </td>
              <td />
            </SubRowDotted>
            <SubRow darkBackground={isEvenRow}>
              <td />
              <td colSpan="2">
                <ShipmentBlock lineData={bomLine} />
              </td>
              <td />
            </SubRow>
            {renderWarrantyRow(bomLine, isEvenRow)}
            <SubRow darkBackground={isEvenRow}>
              <td />
              <td colSpan="2">
                <ItemTrackingDetails lineData={bomLine} />
              </td>
              <td />
            </SubRow>
            {bomLine.unitData.length ? (
              <SubRow darkBackground={isEvenRow}>
                <td />
                <td colSpan="2">
                  <UnitsTable unitsData={bomLine.unitData} />
                </td>
                <td />
              </SubRow>
            ) : null}
          </>
        );
      })}
      {lineData.unitData.length ? (
        <SubRow darkBackground={isEvenRow}>
          <td />
          <td colSpan="2">
            <UnitsTable unitsData={lineData.unitData} />
          </td>
          <td />
        </SubRow>
      ) : null}
    </>
  );
};

const CollapsedRows = ({ show = false, animationDuration = 500, isEvenRow, lineData }) => {
  const animationTimeout = useRef(null);

  const [shouldUnmount, setShouldUnmout] = useState(false);

  // Adds delay before unmounting the component to run the closing animation
  useEffect(() => {
    if (!show) {
      animationTimeout.current = setTimeout(() => setShouldUnmout(true), animationDuration / 2);
    } else if (show) {
      clearTimeout(animationTimeout.current);
      setShouldUnmout(false);
    }
  }, [show, animationTimeout, setShouldUnmout, animationDuration]);

  return shouldUnmount ? null : (
    <CollapsibleRows show={show} animationDuration={animationDuration}>
      {renderCollapsedRows(isEvenRow, lineData)}
    </CollapsibleRows>
  );
};

export { CollapsedRows };
